if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.f-disclosure-list')
      };

      this._isCountry = this.hasAttribute('data-disclosure-country');
      this._defaultCountry = (this.getAttribute('data-default-country') || 'DE').toUpperCase();

      this._USER_FLAG_KEY = 'f_loc_user_selected_v3';
      this._ATTEMPT_KEY = 'f_loc_force_attempts_v3';

      if (this.elements.panel) this.elements.panel.removeAttribute('hidden');

      if (this.elements.button) {
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      }

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

      this.handleDropdownPos();

      // Force default (DE) only before user explicitly selects anything
      // Use form.submit() (same as theme behavior) to avoid fetch issues
      // Delay slightly so other scripts can initialize DOM first
      setTimeout(() => this.maybeForceDefaultCountry(), 0);
      setTimeout(() => this.maybeForceDefaultCountry(), 250);
    }

    safeLSGet(key) {
      try { return localStorage.getItem(key); } catch (e) { return null; }
    }
    safeLSSet(key, val) {
      try { localStorage.setItem(key, val); } catch (e) {}
    }
    safeSSGet(key) {
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    }
    safeSSSet(key, val) {
      try { sessionStorage.setItem(key, val); } catch (e) {}
    }
    safeSSRemove(key) {
      try { sessionStorage.removeItem(key); } catch (e) {}
    }

    maybeForceDefaultCountry() {
      if (!this._isCountry) return;
      if (!this.elements.input) return;

      // If user explicitly selected before, never override
      if (this.safeLSGet(this._USER_FLAG_KEY) === '1') return;

      const current = String(this.elements.input.value || '').toUpperCase();
      const target = this._defaultCountry;

      if (!current || current === target) return;

      // Try a few times max (in case another script keeps overriding)
      const attemptsRaw = this.safeSSGet(this._ATTEMPT_KEY);
      const attempts = parseInt(attemptsRaw || '0', 10) || 0;
      if (attempts >= 3) return;

      const form = this.querySelector('form');
      if (!form) return;

      this.safeSSSet(this._ATTEMPT_KEY, String(attempts + 1));

      this.elements.input.value = target;

      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }

    handleDropdownPos() {
      if (!this.elements.button) return;
      const offsetButton = this.elements.button.getBoundingClientRect().right;
      if ((window.innerWidth - offsetButton) < 220) {
        this.elements.button.nextElementSibling &&
          this.elements.button.nextElementSibling.classList.add('f-disclosure-list__right');
      }
    }

    hidePanel() {
      if (!this.elements.button) return;
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.removeAttribute('open');
    }

    onContainerKeyUp(event) {
      if (!event || !event.code) return;
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button && this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();

      const form = this.querySelector('form');
      if (!form || !this.elements.input) return;

      // User explicitly chose -> lock (never force default again)
      this.safeLSSet(this._USER_FLAG_KEY, '1');
      this.safeSSRemove(this._ATTEMPT_KEY);

      this.elements.input.value = event.currentTarget.dataset.value;

      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }

    openSelector() {
      if (!this.elements.button) return;
      this.elements.button.focus();
      this.toggleAttribute('open');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const related = event && event.relatedTarget;
      const shouldClose =
        (related && related.nodeName === 'BUTTON') ||
        (related && !related.classList.contains('f-disclosure-list__option'));

      if (related === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
}